import { useContext, useState } from "react";
import images from "../../../images";
import ProfileDropDown from "./ProfileDropDown";
import Svg from "../../Helper/Svg";
import ThemeSelector from "../ThemeSelector";
import translate from "../../../Utils/translate";
import UserContextProvider from "../../../Context/UserContext";

export default function Profile() {
  const [showNav, setShowNav] = useState(false);
  const { logout, userInfo } = useContext(UserContextProvider);

  function getUserName() {
    return `${userInfo?.username?.[0].toUpperCase()}${userInfo?.username?.substring(1)}`;
  }

  const defaultProfileClass =
    "flex justify-center items-center bg-theme-secondary rounded-full p-default cursor-pointer transition-[background] hover:bg-theme-primary-hover";

  const defaultDropDownClass =
    "absolute z-20 top-full right-0 shadow-[-10px_20px_55px_-15px_#000000cf] p-2 w-44 mt-default rounded-default bg-theme-secondary";

  return (
    <div className="relative sm:w-full">
      <button
        className={`${defaultProfileClass} sm:justify-between sm:rounded-default sm:w-full`}
        onBlur={() => setShowNav(false)}
        onClick={() => setShowNav(!showNav)}
      >
        <span className="hidden sm:block">{getUserName()}</span>
        <Svg icon={images.icons.user} />
      </button>

      {showNav && (
        <ul className={`${defaultDropDownClass} sm:left-0 sm:w-full`}>
          <div className="sm:hidden">
            <ThemeSelector />
          </div>

          <ProfileDropDown onClick={logout}>
            <h1>{translate("forms.buttons.logout")}</h1>
            <Svg icon={images.icons.logout} />
          </ProfileDropDown>
        </ul>
      )}
    </div>
  );
}
